import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { postSituationApiCrud, type PostSituationRequest } from "@/generated/fastapi";

export async function postSituation(
  accessToken: string | null | undefined,
  request: PostSituationRequest,
) {
  const response = await postSituationApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to submit situation (${response.status})`);
  }

  return response.data;
}
